import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { roadmapSettingsResource } from '@jira/router-resources__roadmap/src/roadmapSettingsResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareBoardsTimelineRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwareBoardsTimelineRoute.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';
import Roadmap, {
	LazyRoadmap,
} from './ui/project-settings/product-routes/software/board-settings/roadmap/index.tsx';

export const projectSettingsSoftwareBoardsTimelineRouteEntry: Route = createEntry(
	projectSettingsSoftwareBoardsTimelineRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: 'board-settings-apps.roadmap-settings-page.page.load',
		// eslint-disable-next-line no-restricted-syntax
		component: Roadmap,
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources(), roadmapSettingsResource],
		forPaint: [LazyAtlassianNavigation, LazyRoadmap],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
